export const LocalStorageKeys = {
  PKCE_CODE_VERIFIER: 'PKCE_CODE_VERIFIER',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  ID_TOKEN: 'ID_TOKEN',
  EXPIRATION: 'EXPIRATION',
  LOGIN_IN_PROGRESS: 'LOGIN_IN_PROGRESS',
  FIRST_LOGIN_ATTEMPT: 'FIRST_LOGIN_ATTEMT',
  IS_AUTHENTICATED: 'IS_AUTHENTICATED',
  HAS_ACCESS_DO: 'HAS_ACCESS_DO',
  USER_EMAIL: 'USER_EMAIL',
  USER_NAME: 'USER_NAME'
};
